$(document).ready(function() {
	$(document).on("click", ".signups-button", function(e){
		e.preventDefault();
		var signup_modal_id = $(this).attr('data-modaltarget');
		var signup_modal_target = $(this).attr('data-modalcontent');
		$(signup_modal_id).modal("show");
		$(signup_modal_id + '_content').html("<iframe frameborder='0'></iframe>");
		$(signup_modal_id + '_content').find('iframe').first().attr('src', signup_modal_target);
	});

	$(document).on("click", ".off-btn", function(e){
		e.preventDefault();
		var signup_modal_id = $(this).attr('data-modaltarget');
		var signup_modal_target = $(this).attr('data-modalcontent');
		$(signup_modal_id).modal("show");
		$(signup_modal_id + '_content').html("<iframe frameborder='0'></iframe>");
		$(signup_modal_id + '_content').find('iframe').first().attr('src', signup_modal_target);
	});

	setTimeout( function(){
		$(".ib-parts").addClass("ontext");
	} , 6000);

});
